import { Col, Divider, Image, Row } from 'antd';
import CommonFormAnt from 'commons/Forms/CommonFormAnt';
import {
    commonElement,
    commonInput,
    commonInputRows
} from 'commons/Forms/formsComponents/formTypes';
import { openNotification } from 'commons/Notifications';
import logoImg from 'images/logo.png';
import { useEffect } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import ServiceAuth from 'services/auth';

const formFields: Array<commonInput | commonInputRows | commonElement> = [
    {
        type: 'string',
        name: 'newpassword',
        label: 'Nuova passaword',
        placeholder: 'Inserire password',
    },
];

const ChangedPassword = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    let token = searchParams.get("token")

    const doChangePassword = async (data) => {
        data.token = token;
        ServiceAuth.changePassword(data).then((res) => {
            openNotification({
                message: 'OK',
                description: 'Password modificata correttamente',
                type: 'success',
            });
        });
    };

    return (
        <Row justify="space-around" align="middle">
            <Col span={8} style={{ margin: '6% auto', textAlign: 'center' }}>
                <Image src={logoImg} />
                <section className="appLogin">
                    <h1><strong>INSERIRE NUOVA PASSWORD</strong></h1>
                    <Divider />
                    <CommonFormAnt
                        autocomplete={true}
                        fields={formFields}
                        onSubmit={(data) => doChangePassword(data)}
                        submitText="Invia"
                        submitOnEnterKey
                    />
                </section>
                <p className="additional-info">
                    Torna alla <Link to="/">Login</Link>
                </p>
            </Col>
        </Row>

    );
};

export default ChangedPassword;
